module.exports = __webpack_public_path__ + "static/img/17-1.16ba0c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/17-1.jpg
// module id = rrrU
// module chunks = 0